// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___u4Qp7","root__subtitle":"style-module__root__subtitle___Cyfft","root_list":"style-module__root_list___zN6eB","root_list__link":"style-module__root_list__link___oqHUM","root_list__item_disabled":"style-module__root_list__item_disabled___jimEA","root_list__item_active":"style-module__root_list__item_active___nOUcu","root_list__icon":"style-module__root_list__icon___huNnu"};
    if(module.hot) {
      // 1697460475202
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  